import _ from 'lodash'
import Amplify, * as AmplifyModules from 'aws-amplify'
import App from './App'
import awsconfig from './aws-exports'
import Vue from 'vue'
import { AmplifyPlugin } from 'aws-amplify-vue'
import { router } from './router'
import { store } from './store/store'
import {isShopifyEnv} from './utilities/environment'

import ElementUI from 'element-ui'
import Hammer from 'hammerjs'
import locale from 'element-ui/lib/locale/lang/en'

// GLOBAL CSS IMPORTS:
import 'element-ui/lib/theme-chalk/index.css'
import './style/sass/screen.scss'

Amplify.configure(awsconfig)

Vue.config.productionTip = false

Vue.directive('tap', {
  bind: function (el, binding) {
    if (typeof binding.value === 'function') {
      const mc = new Hammer(el)
      mc.on('tap', binding.value)
      mc.get('tap').set({ time: 10000 })
    }
  }
})

Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(ElementUI, { locale })

class UncommonProductCustomizer {
  static personalizeButtonId = 'init-customizer';
  static variantSkuSelectElementId = 'variant-sku-selector';

  static appElementId = 'un_app_container';
  static artRendererElementId = 'art_renderer'

  constructor (config) {
    this.app = null

    const defaults = {
      personalizeButtonId: UncommonProductCustomizer.personalizeButtonId,
      skuSelectId: UncommonProductCustomizer.variantSkuSelectElementId
    }

    this.config = _.merge({}, defaults, config)

    this.skuSelectEl = document.getElementById(this.config.skuSelectId)
    this.personalizeBtnEl = document.getElementById(this.config.personalizeButtonId)
  }

  get appElement () {
    return document.getElementById(UncommonProductCustomizer.appElementId)
  }

  get artRendererElement () {
    return document.getElementById(UncommonProductCustomizer.artRendererElementId)
  }

  createRootApp () {
    return new Vue({
      router,
      store,
      el: `#${UncommonProductCustomizer.appElementId}`,
      components: { App },
      template: '<App/>',

      created: function () {
        document.body.style.overflowY = 'hidden'
      },

      destroyed: function () {
        document.body.style.overflowY = 'scroll'
      }
    })
  }

  get selectedSku () {
    // Get the currently selected item from the Variant/SKU <Select /> Field
    return this.skuSelectEl.options[this.skuSelectEl.selectedIndex].dataset.sku
  }

  set currentGlobalSku (skuValue) {
    window.currentGlobalSku = skuValue
  }

  bindVariantSelectionHandler () {
    // When the select-field containing Product Variant SKU's changes,
    // update the global selected SKU.
    //
    // Could we just read this from the select element on-demand instead?
    // why duplicate this state on the window object?
    //
    this.skuSelectEl.addEventListener('change', () => {
      this.currentGlobalSku = this.selectedSku
    })

    // Also, bootstrap the global sku w/ whatever is initially selected
    this.currentGlobalSku = this.selectedSku
  }

  bindCustomizerLaunchHandler () {
    // When the 'Personalize This Product' button is clicked,
    // we build/initialize the customizer.
    this.personalizeBtnEl.addEventListener('click', () => {
      this.buildCustomizer()
    })
  }

  buildCustomizer () {
    if (this.appElement) {
      // The application already exists, so tear it down.
      this.app.$destroy()
    } else {
      // Create the container to house the application.
      var containerEl = document.createElement('div')
      containerEl.setAttribute('id', UncommonProductCustomizer.appElementId)
      document.body.appendChild(containerEl)
    }

    this.app = this.createRootApp()
  }

  destroyCustomizer () {
    if (!this.appElement) return

    this.app.$destroy()
    this.appElement.remove()

    if (this.artRendererElement) {
      this.artRendererElement.remove()
    }
  }

  init () {
    if (isShopifyEnv()) {
      // In Shopify mode, we bind callbacks which will boot the
      // customizer after a user click event/action.
      this.bindVariantSelectionHandler()
      this.bindCustomizerLaunchHandler()
    } else {
      // In development/gold mode, we boot the customizer automatically.
      this.buildCustomizer()
    }
  }
}

document.addEventListener('DOMContentLoaded', function (event) {
  // If the customizer button is found, kick things off by
  // booting up the customizer.

  if (document.getElementById(UncommonProductCustomizer.personalizeButtonId)) {
    window.UNCOMMON = new UncommonProductCustomizer()
    window.UNCOMMON.init()
  }
})



// WEBPACK FOOTER //
// ./uncommon-client/main.js